import { Injectable, OnDestroy } from '@angular/core';
import { BASE_SITE_CONTEXT_ID, SiteContextParamsService, StatePersistenceService } from 'haba-core';
import { BehaviorSubject, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SearchHistoryPersistenceService implements OnDestroy {
  history$ = new BehaviorSubject<string[]>([]);
  protected subscription = new Subscription();
  protected key = 'SearchHistory';
  constructor(
    protected statePersistenceService: StatePersistenceService,
    protected siteContextParamsService: SiteContextParamsService
  ) {}

  public initSync() {
    this.subscription.add(
      this.statePersistenceService.syncWithStorage({
        key: this.key,
        state$: this.history$,
        context$: this.siteContextParamsService.getValues([BASE_SITE_CONTEXT_ID]),
        onRead: (state) => this.onRead(state),
      })
    );
  }

  public add(value: string): void {
    if (!value) {
      return;
    }
    const currentSearches = new Set(this.history$.getValue());
    currentSearches.add(value);
    this.history$.next(Array.from(currentSearches));
  }

  public clear(value?: string): void {
    if (!value) {
      this.history$.next([]);
    } else {
      const currentSearches = new Set(this.history$.getValue());
      currentSearches.delete(value);
      this.history$.next(Array.from(currentSearches));
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  protected onRead(state: string[] | undefined) {
    this.history$.next(state || []);
  }
}

export function searchHistoryPersistenceFactory(
  searchHistoryPersistenceService: SearchHistoryPersistenceService
) {
  return () => searchHistoryPersistenceService.initSync();
}
